/**
 * Extracts the filename from the Content-Disposition header.
 */
export const extractFileNameFromDisposition = (disposition) => {
  if (!disposition) return null;
  const match = disposition.match(/filename="(.+?)"/);
  return match?.[1] ? decodeURIComponent(match[1]) : null;
};

/**
 * Generates a fallback file name based on content type and timestamp.
 */
export const generateFallbackFileName = (contentType) => {
  const ext = contentType.includes('pdf') ? 'pdf' : 'docx';
  return `document-${Date.now()}.${ext}`;
};

/**
 * Saves a Blob as a file using a temporary anchor element.
 */
export const saveBlobAsFile = (data, type, fileName) => {
  const blob = new Blob([data], { type });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};